import { render, staticRenderFns } from "./CardInColumn.vue?vue&type=template&id=7e68533a&scoped=true"
import script from "./CardInColumn.vue?vue&type=script&lang=js"
export * from "./CardInColumn.vue?vue&type=script&lang=js"
import style0 from "./CardInColumn.vue?vue&type=style&index=0&id=7e68533a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e68533a",
  null
  
)

export default component.exports